import React from 'react';
import { cn } from 'lib/utils';

interface DrawerProps {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  children: React.ReactNode;
  hasSdk?: boolean;
}

const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  toggle,
  children,
  hasSdk = false,
}) => {
  return (
    <div>
      <div
        className={cn(
          'fixed inset-0 bg-black/50 z-[1040]',
          isOpen ? 'block' : 'hidden'
        )}
        onClick={toggle}
      />
      {/* TW v4 dynamic spacing scale (0.25rem unit): w-120 = 480px, w-225 = 900px
          — the original drawer widths; negative -right-* hides it off-canvas. */}
      <div
        className={cn(
          'fixed top-0 h-full bg-white z-1050 shadow-[4px_0_16px_rgba(0,0,0,0.4)] rounded-lg transition-[right] duration-300 ease-in-out',
          hasSdk ? 'w-full sm:w-225' : 'w-full sm:w-120',
          isOpen
            ? 'right-0'
            : hasSdk
            ? '-right-full sm:-right-225'
            : '-right-full sm:-right-120'
        )}
      >
        <div className="overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

export { Drawer };
